import React, { Fragment, useEffect, useState } from "react";
import { Button, Message, Popup, PopupProps, Segment } from "semantic-ui-react";
import { useBool, useLoading } from "../../../../sg-core";
import { ServiceContext } from "../../../store";
import { useMakeObservationPackage } from "../../data/observation/useMakeObservationPackage";
import IObservation from "../../interfaces/IObservation";
import { makeAnonObservationHref } from "../../utils/havainnot.helper";

interface AnonymousObservationPopupProps extends Pick<PopupProps, "trigger" | "open"> {
    observation: IObservation;
};

export const AnonymousObservationPopup: React.FC<AnonymousObservationPopupProps> = ({
    observation,
    ...popupProps
}) => {
    const observationService = ServiceContext.observation;
    const { makePackage } = useMakeObservationPackage();

    const [packageId, setPackageId] = useState<string>();
    const {
        loading,
        startLoading,
        loadSuccess,
        loadErrored,
        loadError
    } = useLoading();

    const [open, openPopup, closePopup] = useBool(popupProps?.open);


    useEffect(() => {
        const go = async () => {
            try {
                startLoading();

                const observationPackage = await makePackage({ observation });
                if (!observationPackage.isSuccess) {
                    throw observationPackage.error;
                };

                const result = await observationService.saveHistoryData(observationPackage.value);
                if (!result.isSuccess) {
                    throw result.error;
                };

                setPackageId(result.value.id);
                loadSuccess()
            } catch (error) {
                loadErrored((error as Error).message);
            }
        };

        if (open && !packageId && !loading) {
            go();
        };
    }, [packageId, open]); // eslint-disable-line



    return (
        <Popup
            {...popupProps}
            on="click"
            open={open}
            onClose={closePopup}
            onOpen={openPopup}
            content={(
                <Fragment>
                    <Segment loading={loading} basic >
                        {loadError && <Message negative> {loadError} </Message>}
                        {packageId && (
                            <Button as="a" href={makeAnonObservationHref(packageId, "fi")} target="_window">  Avaa anonyymi näkymä </Button>
                        )}
                    </Segment>
                </Fragment >
            )}

        />
    );
};
